var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.question.answers, function (answer, answerIndex) {
      return _c(
        "div",
        {
          key: answerIndex,
          staticStyle: { display: "flex", "align-items": "center" },
        },
        [
          _c("div", { staticStyle: { display: "inline-flex" } }, [
            _vm._v(_vm._s(answer.label) + "."),
          ]),
          _c("div", {
            staticStyle: { "margin-left": "4px" },
            domProps: { innerHTML: _vm._s(answer.value || "") },
          }),
          !_vm.submission.isQuestionPaper && _vm.isAnswerShown
            ? _c(
                "div",
                {
                  staticClass: "ml-2",
                  staticStyle: { display: "inline-flex" },
                },
                [
                  _vm.isStudentAnswerShown(answer.key)
                    ? _c("div", [
                        !_vm.submission.isStudentWork
                          ? _c("span", {
                              style: {
                                color: _vm.isCorrect ? "#4bca81" : "#d4504c",
                                fontWeight: "bold",
                                fontSize: "14px",
                              },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.isCorrect ? "&#10003;" : "&#x2715;"
                                ),
                              },
                            })
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }